import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./EditArticles.css";

const EditArticles = () => {
  const [articles, setArticles] = useState([]);
  const [showModal, setShowModal] = useState(false); // État pour afficher/masquer le modal
  const [articleToDelete, setArticleToDelete] = useState(null); // L'article à supprimer

  
  const fetchArticles = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/articles`);
      const data = await res.json();
      console.log(data);

      if (Array.isArray(data)) {
        setArticles(data);
      } else {
        console.error("Les articles ne sont pas au format attendu");
      }
    } catch (err) {
      console.error("Erreur de chargement des articles :", err);
    }
  };

  const handleDeleteClick = (id) => {
    setArticleToDelete(id); // Stocke l'id de l'article à supprimer
    setShowModal(true); // Affiche le modal de confirmation
  };

  const deleteArticle = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/articles/${articleToDelete}`, {
        method: "DELETE",
      });

      if (res.ok) {
        setArticles((prevArticles) => prevArticles.filter((a) => a._id !== articleToDelete));
        setShowModal(false); // Ferme le modal après suppression
      } else {
        alert("Erreur lors de la suppression");
      }
    } catch (err) {
      console.error("Erreur suppression :", err);
    }
  };

  const cancelDelete = () => {
    setShowModal(false); // Ferme le modal sans supprimer
    setArticleToDelete(null); // Réinitialise l'article à supprimer
  };

  useEffect(() => {
    fetchArticles();
  }, []);

  return (
    <div className="edit-articles-container">
      <h2 className="edit-title">Éditer ou Supprimer un Article</h2>
      {articles.length === 0 ? (
        <p>Aucun article disponible.</p>
      ) : (
        <div className="articles-grid">
          {articles.map((article) => (
            <div key={article._id} className="article-card">
              {/* Affichage de l'image */}
              {article.mainImage && (
                <img
                  src={article.mainImage}
                  alt={article.title}
                  className="article-image"
                />
              )}

              {/* Titre */}
              <h3>{article.title}</h3>

              {/* Date */}
              <p className="article-date">
                {new Date(article.date).toLocaleDateString("fr-FR")}
              </p>

              {/* Extrait du contenu */}
              <p className="article-extrait">
                {article.content.slice(0, 200)}...
              </p>

              {/* Actions */}
              <div className="article-actions">
                <Link to={`/EditSingleArticle/${article._id}`} className="edit-btn">
                  Modifier
                </Link>
                <button
                  onClick={() => handleDeleteClick(article._id)}
                  className="delete-btn"
                >
                  Supprimer
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modal de confirmation */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Voulez-vous vraiment supprimer cet article ?</h3>
            <div className="modal-actions">
              <button onClick={deleteArticle} className="modal-btn delete-btn">
                Supprimer
              </button>
              <button onClick={cancelDelete} className="modal-btn cancel-btn">
                Annuler
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditArticles;
